import React from "react";
import { View, StyleSheet, TouchableOpacity, ViewStyle } from "react-native";
import upperFirst from "lodash.upperfirst";
import toLower from "lodash.tolower";
import { PaymentSourceType } from "../../../enums";
import { Text, typography, Icon, Icons, theme } from "ui-components";
import { fontWeights } from "ui-components/dist/theme/typography";
import { PaymentMethodProps } from "../wallet-payment-methods/payment-method";
import { Stack } from "../../layout/stack";
import automationTestingLocators from ".././../../screens/new/utils/automation-testing-locators.json";
import { dbToAccountTypeFieldValueMapping } from "../../../screens/new/utils/helper";
export interface PaymentMethodSelectionProps extends PaymentMethodProps {
  type?: PaymentSourceType;
  onPressItem?: any;
  disabled?: boolean;
  containerStyle?: ViewStyle;
  iconsSizeCC?: number;
  nickname?: string;
  paymentMethodDetails?: any;
}

export const PaymentMethodSelection = (paymentMethodProps: PaymentMethodSelectionProps) => {
  let {
    active = true,
    last_four_digits,
    bank_account_type,
    allowedPayments,
    useRadioButton = true,
    checkedStatus,
    setSelectedWrapped,
    fullName,
    card_type,
    shouldDisableCC = false,
    type: paymentType,
    allowCC = true,
    allowACH = true,
    onPressItem,
    disabled,
    containerStyle,
    iconsSizeCC,
    nickname,
    paymentMethodDetails,
    ...otherProps
  } = paymentMethodProps;

  let isBankAccount = paymentType == PaymentSourceType.BANK_ACCOUNT;
  let styles = getStyles(active, paymentMethodDetails?.nickname);

  return (
    <>
      <TouchableOpacity
        style={[styles.container, containerStyle]}
        disabled={disabled}
        onPress={() => {
          onPressItem(paymentMethodDetails);
        }}
        {...automationTestingLocators.paymentMethodSelection.paymentMethodSelectionButton}>
        <Stack style={{ flex: 1 }} space="tiny">
          <View>
            <Text
              style={styles.title}
              {...(isBankAccount
                ? automationTestingLocators.paymentMethodSelection.bankInfo
                : automationTestingLocators.paymentMethodSelection.cardInfo)}>
              {isBankAccount
                ? `${dbToAccountTypeFieldValueMapping(bank_account_type)} ...xxxx ${last_four_digits}`
                : `${upperFirst(toLower(card_type))} ...xxxx ${last_four_digits}`}
            </Text>
          </View>
          {paymentMethodDetails?.nickname && (
            <View>
              <Text
                style={styles.paymentStatusSubTitle}
                {...automationTestingLocators.paymentMethodSelection.nickname}>
                {paymentMethodDetails?.nickname
                  ? `${paymentMethodDetails?.nickname?.length > 27 ? `${paymentMethodDetails?.nickname.substring(0, 27)}...` : paymentMethodDetails?.nickname}`
                  : null}
              </Text>
            </View>
          )}
        </Stack>
        <View>
          {!isBankAccount && (
            <Icon
              name={
                card_type == "VISA"
                  ? "visa-card"
                  : card_type == "MASTERCARD" || card_type == "MASTER CARD"
                  ? "master-card"
                  : "discover-card"
              }
              size={iconsSizeCC || 30}
              {...automationTestingLocators.paymentMethodSelection.cardTypeIcon}
            />
          )}
        </View>
      </TouchableOpacity>
    </>
  );
};

const getStyles = (active: boolean, nickname: any) => {
  return StyleSheet.create({
    container: {
      flexDirection: "row",
      padding: 16,
      alignItems: "center",
      paddingVertical: !nickname ? 20 : 16,
    },
    title: {
      ...typography.title2,
      fontWeight: fontWeights.Regular,
      color: theme.colors.secondary,
    },
    paymentStatusTitle: {
      ...typography.body,
      fontWeight: fontWeights.Bold,
      color: active ? theme.colors.success : theme.colors.error,
    },
    paymentStatusSubTitle: {
      ...typography.body,
      fontWeight: fontWeights.Regular,
      color: theme.colors.text3,
    },
  });
};
